import React from 'react'
import { sumBy, map, toString, sortBy, includes } from "lodash"
import { Row, Col, ProgressBar, Badge } from 'react-bootstrap'

import RAGIcon from 'FoundationalComponents/RAGIcon'

// DO NOT USE OUTSIDE OF CUSTOMER DEMO'S
const DemoCoverageDetails = (value) => {
  switch (toString(value)) {
    case '0': return { sort: 1, color: 'green', icon: 'check', title: 'Compliant' }
    case '1': return { sort: 2, color: 'amber', icon: 'check', title: 'Not Fully Compliant' }
    case '2': return { sort: 2, color: 'red', icon: 'times',   title: 'Not Compliant' }
    default: return { sort: 3, color: 'red', icon: 'times' }
  }
}

const CVECoverageDetails = (value) => {
  switch (toString(value)) {
    case 'none': return { sort: 1, color: 'green', icon: 'dot', title: 'No CVEs' }
    case 'low': return { sort: 2, color: 'low', icon: 'dot', title: 'Low' }
    case 'medium': return { sort: 3, color: 'medium', icon: 'dot', title: 'Medium' }
    case 'high': return { sort: 4, color: 'high', icon: 'dot', title: 'High' }
    case 'critical': return { sort: 5, color: 'red', icon: 'dot', title: 'Critical' }
  }
}

const DefaultCoverageDetails = (value) => {
  switch (toString(value)) {
    case 'true': return { sort: 1, color: 'green', icon: 'check', title: 'Integrated' }
    case 'false': return { sort: 2, color: 'red', icon: 'times', title: 'Not Integrated' }
    case 'Data Source not integrated to Incognita': return { sort: 4, color: 'lightgrey', icon: 'minus-hexagon', title: 'Data Source not integrated to Incognita' }

    case 'N/A': return { sort: 5, color: 'grey', icon: 'minus', title: 'N/A' }
    default: return { sort: 3, color: 'red', icon: 'times' }
  }
}

const AntiVirusDetails = (value) => {
  switch (value) {
    case 'RunningAndUpToDate':    return { sort: 1, color: 'green', icon: 'check', title: 'Running and Up To Date' }
    case 'RunningAndNotUpToDate': return { sort: 2, color: 'amber', icon: 'check', title: 'Running and Not Up To Date' }
    case 'NotRunning':            return { sort: 3, color: 'amber', icon: 'times', title: 'Not Running' }
    case 'N/A':                   return { sort: 5, color: 'grey',  icon: 'minus', title: 'N/A' }
    default:                      return { sort: 4, color: 'red',   icon: 'times', title: 'Not Detected' }
  }
}

const PatchingDetails = (value) => {
  switch (value) {
    case 'FullyPatched':    return { sort: 1, color: 'green', icon: 'check', title: 'Fully Patched' }
    case 'ApprovedPending': return { sort: 2, color: 'green', icon: 'check', title: 'Approved Pending' }
    case 'InstallError':    return { sort: 3, color: 'amber', icon: 'check', title: 'Install Error' }
    case 'RebootRequired':  return { sort: 4, color: 'amber', icon: 'check', title: 'Reboot Required' }
    case 'NoData':          return { sort: 5, color: 'red',   icon: 'times', title: 'No Data' }
    case 'NoPolicy':        return { sort: 6, color: 'red',   icon: 'times', title: 'No Policy' }
    case 'N/A':             return { sort: 8, color: 'grey',  icon: 'minus', title: 'N/A' }
    default:                return { sort: 7, color: 'red',   icon: 'times', title: 'Not Detected' }
  }
}

const SummaryCell = ({ value }) => {
  const fullCount = sumBy(value, 'count')

  const colors = { critical: 'critical', high: 'high', medium: 'medium', low: 'low', blue: 'primary', green: 'success', red: 'danger', amber: 'warning', grey: 'dark', lightgrey: 'secondary' }

  return (
    <ProgressBar>
      {map(sortBy(value, 'sort'), (status) => (
        <ProgressBar
          title={`${status.title}: ${status.count} / ${fullCount}`}
          variant={colors[status.color]}
          now={(status.count / fullCount) * 100}
          key={status.sort}
        />
      ))}
    </ProgressBar>
  )
}

const PatchingCell = ({ value }) =>  <RAGIcon {...PatchingDetails(value)} />
const AntiVirusCell = ({ value, antivirus_product }) => (
  <div style={{ textAlign: 'center' }}>
    <RAGIcon {...AntiVirusDetails(value)} />

    {antivirus_product}
  </div>
)

export { DemoCoverageDetails, SummaryCell, AntiVirusCell, PatchingCell, AntiVirusDetails, PatchingDetails, DefaultCoverageDetails, CVECoverageDetails }
